<mat-form-field appearance="outline" [class]="size" floatLabel="always">
  <mat-label>{{label}}</mat-label>
  <textarea matInput [ngModel]="value" readonly="readonly"></textarea>
</mat-form-field>